<template>
  <div id="app">
    <HomePageView/>
  </div>
</template>

<script>
// import Home from "@/components/Home.vue"
// import HomePage from "@/components/HomePage.vue"
import HomePageView from "@/components/HomePageView.vue"

export default {
  name: 'App',
  components: {
    // Home
    HomePageView
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50; */
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
</style>
